"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = exports.makeSpacing = exports.sizes = void 0;

var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/values"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

require("../../util/GlobalScript.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

/**
 * @enum {string}
 * @alias Spacing.Sizes
 */
var sizes = {
  /** xs */
  XS: "xs",

  /** sm */
  SM: "sm",

  /** md */
  MD: "md",

  /** lg */
  LG: "lg",

  /** xl */
  XL: "xl",

  /** xx */
  XX: "xx"
};
exports.sizes = sizes;

var noCustomClasses = function noCustomClasses() {
  return {};
};

var spacingGetClassName = function spacingGetClassName(value, placement) {
  var _context;

  return value !== undefined ? (0, _concat.default)(_context = "space-".concat(placement, "-")).call(_context, value) : "";
};
/**
 * @class Spacing
 * @desc Flexible component for adding Spacing. Different from Padding because spacing uses margin, which can collapse.
 * @param {string} [data-id="spacing"]
 *          To define the base "data-id" value for the top-level HTML container.
 * @param {string} [className]
 *      class name(s) to add to the top-level container/div
 * @param {Spacing.Sizes} bottom
 *      Spacing on bottom
 * @param {Spacing.Sizes} left
 *      Spacing on left
 * @param {Spacing.Sizes} right
 *      Spacing on right
 * @param {Spacing.Sizes} top
 *      Spacing on top
 * @param {Spacing.Sizes} vertical
 *      Spacing on top and bottom
 * @param {Spacing.Sizes} horizontal
 *      Spacing on left and right
 * @param {Spacing.Sizes} Spacing
 *      Spacing on all sides
 */


var makeSpacing = function makeSpacing(_ref) {
  var getClassName = _ref.getClassName,
      _ref$makeCustomClasse = _ref.makeCustomClasses,
      makeCustomClasses = _ref$makeCustomClasse === void 0 ? noCustomClasses : _ref$makeCustomClasse;
  return function (_ref2) {
    var children = _ref2.children,
        className = _ref2.className,
        dataId = _ref2["data-id"],
        padding = _ref2.padding,
        _ref2$spacing = _ref2.spacing,
        spacing = _ref2$spacing === void 0 ? padding : _ref2$spacing,
        _ref2$vertical = _ref2.vertical,
        vertical = _ref2$vertical === void 0 ? spacing : _ref2$vertical,
        _ref2$horizontal = _ref2.horizontal,
        horizontal = _ref2$horizontal === void 0 ? spacing : _ref2$horizontal,
        _ref2$bottom = _ref2.bottom,
        bottom = _ref2$bottom === void 0 ? vertical : _ref2$bottom,
        _ref2$left = _ref2.left,
        left = _ref2$left === void 0 ? horizontal : _ref2$left,
        _ref2$right = _ref2.right,
        right = _ref2$right === void 0 ? horizontal : _ref2$right,
        _ref2$top = _ref2.top,
        top = _ref2$top === void 0 ? vertical : _ref2$top,
        props = (0, _objectWithoutProperties2.default)(_ref2, ["children", "className", "data-id", "padding", "spacing", "vertical", "horizontal", "bottom", "left", "right", "top"]);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(className, getClassName(bottom, "bottom"), getClassName(left, "left"), getClassName(right, "right"), getClassName(top, "top"), makeCustomClasses(props)),
      "data-id": dataId
    }, children);
  };
};

exports.makeSpacing = makeSpacing;
var Spacing = makeSpacing({
  getClassName: spacingGetClassName
});

var SpacingPropType = _propTypes.default.oneOf((0, _values.default)(sizes));

Spacing.propTypes = {
  bottom: SpacingPropType,
  left: SpacingPropType,
  right: SpacingPropType,
  top: SpacingPropType,
  vertical: SpacingPropType,
  horizontal: SpacingPropType,
  spacing: SpacingPropType
};
Spacing.defaultProps = {
  "data-id": "spacing"
};
Spacing.sizes = sizes;
var _default = Spacing;
exports.default = _default;